import React, { FC } from 'react'

import { makeStyles, Theme } from '@material-ui/core/styles'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import { useIntl } from 'react-intl'

import ClearIcon from '@material-ui/icons/Clear'
import clsx from 'clsx'
import messages from '../../messages'
import { SpecificationMessages } from '@src/routes/SemiConfigurators/products/crisprgrna/Enum'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(1),
    width: theme.spacing(150),
    height: theme.spacing(20),
  },
  clearButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  mgTop: {
    marginTop: theme.spacing(6),
  },

  title: {
    backgroundColor: theme.palette.grey[50],
  },
}))

interface DeleteAllDialogProps {
  dialogOpen: boolean
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
  type: string
  selectedItem?: any
  onDelete: any
  elementId?: any
}

let titleMsg = ''
let msg = ''
let buttonText = ''

const DeleteAllDialog: FC<DeleteAllDialogProps> = (props) => {
  const classes = useStyles()
  const { dialogOpen, setDialogOpen } = props
  const intl = useIntl()

  const handleClose = (): void => {
    setDialogOpen(false)
  }
  if (props.type === SpecificationMessages.All) {
    titleMsg = intl.formatMessage(messages.CONF_DELETE_ALL_ITEM_DNA_PLATES)
    msg = intl.formatMessage(messages.CONF_DELETE_ALL_ITEM_MSG_DNA_PLATES)
    buttonText = intl.formatMessage(
      messages.CONF_DELETE_ALL_BUTTON_TEXT_DNA_PLATES
    )
  } else if (props.type === SpecificationMessages.Selected) {
    titleMsg = intl.formatMessage(messages.CONF_DELETE_ITEM_DNA_PLATES)
    msg = intl.formatMessage(messages.CONF_DELETE_ITEM_MSG_DNA_PLATES)
    buttonText = intl.formatMessage(messages.CONF_DELETE_BUTTON_TEXT_DNA_PLATES)
  }
  const handleDelete = (): void => {
    if (
      props.type === SpecificationMessages.Selected ||
      props.type === SpecificationMessages.All
    ) {
      props.onDelete(props.selectedItem, props.type, props.elementId)
      setDialogOpen(false)
    }
  }

  return (
    <div className={clsx(dialogOpen && classes.root)}>
      <Dialog onClose={handleClose} open={dialogOpen} maxWidth="md">
        <DialogTitle className={classes.title}>{titleMsg}</DialogTitle>
        <IconButton
          className={classes.clearButton}
          color="primary"
          onClick={handleClose}
        >
          <ClearIcon />
        </IconButton>
        <DialogContent className={clsx(classes.root, classes.mgTop)}>
          {msg}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="primary" variant="contained">
            {buttonText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default DeleteAllDialog
